import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@bya/auth/services/authentication.service';
import { HelpDeskService } from '@bya/base/services/helpDesk.service';


@Component({
  selector: 'logout-callback',
  templateUrl: './logout-callback.component.html',
    styleUrls: ['./logout-callback.component.scss']
})
export class LogoutCallBackComponent implements OnInit {

  error : boolean;

  constructor(
    private authService: AuthService,
     private router: Router,
     private route: ActivatedRoute,
     private _helpDeskService:HelpDeskService
     ) {}

  ngOnInit() {
    this.authService.completeLogout().then(_=>
        {
            this._helpDeskService.closeTicket();
        });      
    this.router.navigate(['/']);    //home
  }
}
